"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createEscaper = _interopRequireDefault(require("./_createEscaper.js"));

var _unescapeMap = _interopRequireDefault(require("./_unescapeMap.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Function for unescaping strings from HTML interpolation.
var _default = (0, _createEscaper.default)(_unescapeMap.default);

exports.default = _default;